import * as React from "react";

import {
  ActionPrimary,
  ProminentErrorMessageBox,
  ReCaptcha,
  SingleLineTextInput,
} from "../../Common";

import {
  useForgotPasswordForm,
  useReactForgotPasswordInitialState,
} from "../providers";

export const FormForgotPassword: React.FunctionComponent = () => {
  const { initialState } = useReactForgotPasswordInitialState();
  const { forgot_password_form_recaptcha } = initialState;

  const {
    form: forgotPasswordForm,
    onFormFieldFocus,
    onFormInputChange,
    onFormInputBlur,

    resetPassword,
  } = useForgotPasswordForm();

  const isResetPasswordButtonDisabled = React.useMemo(() => {
    let areAllTheFieldsFilledIn = (forgotPasswordForm?.email?.length || 0) > 0;

    const isResetPasswordButtonDisabled = !areAllTheFieldsFilledIn;

    return isResetPasswordButtonDisabled;
  }, [forgotPasswordForm]);

  const onResetPasswordClick: React.MouseEventHandler<HTMLButtonElement> = async (
    event
  ) => {
    event.preventDefault();
    const isRecaptchaV3 = initialState.forgot_password_form_recaptcha?.recaptchaEnabled as unknown as string === 'reCAPTCHA v3 Invisible';

    if (isRecaptchaV3 && (window as any).grecaptcha) {
      try {
        const captchaWrapperId = initialState.forgot_password_form_recaptcha?.recaptchaId + "-react-wrapper";
        const recaptchaElement = (document.querySelector("#" + captchaWrapperId)?.querySelector(".g-recaptcha-response")) as HTMLTextAreaElement;
        const token = await (window as any).grecaptcha.execute(
          (window as any).recaptchaSiteKey,
          {action: "validate_captcha"}
        );

        if (recaptchaElement && token) {
          recaptchaElement.value = token;
        }
      } catch (e) {
        console.log(e);
      }
    }

    resetPassword();
  };

  return (
    <form>
      <SingleLineTextInput
        name="email"
        type="email"
        inputMode="email"
        autoComplete="email"
        displayName="Email Address"
        form={forgotPasswordForm}
        required
        onFocus={onFormFieldFocus}
        onChange={onFormInputChange}
        onBlur={onFormInputBlur}
      />

      <ReCaptcha
        recaptchaConfiguration={forgot_password_form_recaptcha}
        name="recaptcha"
        form={forgotPasswordForm}
        onChange={onFormInputChange}
      />

      <ProminentErrorMessageBox />

      <ActionPrimary
        name="reset-password"
        onClick={onResetPasswordClick}
        disabled={isResetPasswordButtonDisabled}
      >
        {`RESET PASSWORD`}
      </ActionPrimary>
    </form>
  );
};
